enum FilterType {
  All,
  Completed,
  NotCompleted,
}

export default FilterType;
